'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import H3 from 'UIComponents/elements/headings/H3';
import UIList from 'UIComponents/list/UIList';
import UILink from 'UIComponents/link/UILink';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import ThemeProviderDetailsResponse from '../../records/ThemeProviderDetailsResponse';

const NoopExternalIcon = () => null;

const ExternalLink = props => /*#__PURE__*/_jsx(UILink, Object.assign({}, props, {
  ExternalIcon: NoopExternalIcon,
  external: true
}));

const ThemeContactInfo = ({
  chatUrl,
  facebookUrl,
  getThemeEventSelectorId = () => undefined,
  onTrackInteraction,
  phone,
  provider = {},
  supportEmail
}) => {
  const trackInteraction = useCallback((...args) => {
    if (onTrackInteraction) {
      onTrackInteraction(...args);
    }
  }, [onTrackInteraction]);
  const {
    name: providerName
  } = provider;
  const [phoneNumber, phoneExtension] = phone ? phone.split('-') : [];
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H3, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystemMarketplaceCore.themes.details.contact.title",
        options: {
          providerName
        }
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      children: [/*#__PURE__*/_jsxs(UICopyButton, {
        "data-hs-analytics-id": getThemeEventSelectorId('SIDEBAR-EMAIL'),
        onClick: () => trackInteraction('click copy email address'),
        use: "link",
        value: supportEmail,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "email"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.themes.details.contact.supportEmail"
        })]
      }), chatUrl && /*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getThemeEventSelectorId('SIDEBAR-CHAT'),
        href: chatUrl,
        onClick: () => trackInteraction('click live chat link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "messages"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.themes.details.contact.chatUrl"
        })]
      }), facebookUrl && /*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getThemeEventSelectorId('SIDEBAR-FACEBOOK'),
        href: facebookUrl,
        onClick: () => trackInteraction('click facebook link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "socialBlockFacebook"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.themes.details.contact.facebookUrl"
        })]
      }), phone && /*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getThemeEventSelectorId('SIDEBAR-PHONE'),
        href: `tel: ${phoneNumber}`,
        onClick: () => trackInteraction('click phone number link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "calling"
        }), /*#__PURE__*/_jsx(FormattedPhoneNumber, {
          value: phoneNumber,
          extension: phoneExtension
        })]
      })]
    })]
  });
};

ThemeContactInfo.propTypes = {
  chatUrl: PropTypes.string,
  facebookUrl: PropTypes.string,
  getThemeEventSelectorId: PropTypes.func,
  onTrackInteraction: PropTypes.func,
  phone: PropTypes.string,
  provider: PropTypes.instanceOf(ThemeProviderDetailsResponse).isRequired,
  supportEmail: PropTypes.string.isRequired
};
export default ThemeContactInfo;